import { IS_PROD_ENV } from '@gto/helpers/env-checkers'
import { deriveDevAppFromHostname, getActivePreviewBackendPr } from '@gto/helpers/runtime-env'

/**
 * A URL on the GTO Wizard app that pairs with this admin host.
 *
 * On a team host (admin.<team>.dev.gtowizard.com) the paired app.<team> host
 * exists and talks to that team's backend, so the URL goes there. Anywhere else
 * (localhost, a CF Pages PR preview, prod) there is no matching per-host app, so
 * it falls back to shared dev or prod. A `?api=<n>` preview-backend override (see
 * getApiBaseUrl) rides along as the same `api` param: the shared dev app honours
 * it at boot, so the app reads from the backend admin-web writes to.
 */
export const gwAppUrl = (path: string): URL => {
  const origin = IS_PROD_ENV()
    ? 'https://app.gtowizard.com'
    : (deriveDevAppFromHostname(window.location.hostname) ?? 'https://app.dev.gtowizard.com')
  const url = new URL(path, origin)
  const previewBackendPr = IS_PROD_ENV() ? null : getActivePreviewBackendPr()
  if (previewBackendPr !== null) {
    url.searchParams.set('api', previewBackendPr)
  }

  return url
}
